import React from "react"
import { createLeadList } from "~/react/components/lead-save-manager"
import { ResultType } from "~/react/components/multi_domain_search/result"
import {
  multi_domain_search_leads_search_index_path,
  api_lead_path,
} from "~/lib/routes"

export const useLeadsListSave = (
  results: ResultType[],
  setLeadsLists: React.Dispatch<
    React.SetStateAction<{ id: number; name: string }[]>
  >,
  setResults: React.Dispatch<
    React.SetStateAction<ResultType[]>
  >,
) => {
  const handleLeadsListSave = async (
    name: string,
    listId: number,
    emailId: number,
  ) => {
    let list = { id: listId, name }
    if (listId === null) {
      // Create a new list
      list = await createLeadList(name)
      if (list) {
        setLeadsLists((prev) => [...prev, list])
      } else {
        return
      }
    }

    const result = results.find((result) => result.id === emailId)
    if (!result) {
      console.error("Result not found for emailId", emailId)
      return
    }

    const lead = result.lead

    if (!lead) {
      // Create a new lead
      const response = await fetch(
        multi_domain_search_leads_search_index_path(),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
              ?.content,
          },
          body: JSON.stringify({
            email_id: emailId,
            leads_list_id: list.id,
          }),
        },
      )
      const json = await response.json()

      if (response.ok) {
        setResults((prev) =>
          prev.map((result) =>
            result.id === emailId ? { ...result, lead: json.data } : result,
          ),
        )
      } else {
        App.displayFlash("error", "Failed to save lead to a list")
      }
    } else {
      const response = await fetch(
        api_lead_path(lead.id, { api_version: "v2", api_key: gon.api_key }),
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            leads_list_ids: [...lead.leads_list_ids, list.id],
          }),
        },
      )

      if (response.ok) {
        setResults((prev) =>
          prev.map((result) =>
            result.id === emailId && result.lead
              ? {
                  ...result,
                  lead: {
                    ...result.lead,
                    leads_list_ids: [
                      ...new Set([...result.lead.leads_list_ids, list.id]),
                    ],
                  },
                }
              : result,
          ),
        )
      } else {
        App.displayFlash("error", "Failed to save lead to a list")
      }
    }
  }

  return handleLeadsListSave
}

